export default function Loading ({type}) {

    let content;

    switch(type) {
        case 'xs':
            content = (
                <i className='bx bx-loader-alt bx-spin loading xs' ></i>
            );
            break;
        case 'small':
            content = (
                <i className='bx bx-loader-alt bx-spin loading' ></i>
            );
            break;
        case 'large':
            content = (
                 <i className='bx bx-loader-alt bx-spin loading large'></i>
            );
            break;
        case 'page':
            content = (
                <div className="pageLoading">
                    <i className='bx bx-loader-alt bx-spin loading page'></i>
                </div>
            );
            break;
        default:
            content = <p>[loading] not found</p>;
    }

    return content;
}